import Vue from "vue"

import resetMixin from "~/mixins/store/resetToInitialState"

const initialState = function () {
  return {
    first_name: "",
    last_name: "",
    birthday: null,
    nationality: null,
    country_of_residence: null,
    is_liable: "",
    entity: "",
    street: "",
    city: "",
    postal_code: "",
    vat_number: "",
    id: 0,
  }
}

export const state = initialState

export const mutations = {
  SET: function (state, data) {
    for (let key in data) Vue.set(state, key, data[key])
  },
  ...resetMixin.mutations,
}

export const actions = {
  RESET: function ({ commit }) {
    commit("RESET", initialState())
  },
  FETCH: async function ({ commit, dispatch }) {
    try {
      const resp = await this.$axios.$get("/wallet/legaldata/")
      commit("SET", {
        ...resp[0],
        birthday: resp[0].birthday * 1000,
      })
    } catch (error) {
      dispatch("RESET")
    }
  },
  UPDATE_ON_SERVER: async function (
    { state, getters, rootState },
    new_legal_data
  ) {
    const sendFn = getters["CAN_PATCH"] ? this.$axios.$patch : this.$axios.$post
    let url = "/wallet/legaldata/"

    if (getters["CAN_PATCH"]) url += state.id + "/"
    return await sendFn(url, {
      ...new_legal_data,
      id: undefined,
      user: rootState.user.id,
      birthday: new_legal_data.birthday / 1000,
    })
  },
}

export const getters = {
  INITIAL_STATE: function () {
    return initialState()
  },
  CAN_PATCH: function (state) {
    return state.id > 0
  },
}
